/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { loadCurrencies } from "@eisinc/App/Services/loadCurrencies";
import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { setCookie } from "@insite/client-framework/Common/Cookies";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { getSession, GetSessionApiParameter, Session } from "@insite/client-framework/Services/SessionService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSession";

// eslint-disable-next-line
import Cookies from "universal-cookie/es6/Cookies"



type HandlerType = ApiHandlerDiscreteParameter<
    GetSessionApiParameter & HasOnComplete<{ apiResult: Session }> & { isSessionUpdate?: true },
    GetSessionApiParameter,
    Session
>;

export type CurrencyType = {
    currencyCode: string;
    currencySymbol: string;
    description: string;
    id: string;
    isDefault: boolean;
};

export const XngRequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSession(props.apiParameter);

    if (props.apiResult.isAuthenticated === false) {
        if ((props.getState() as CustomAppState).xLoadCurrencies.currenciesState.length === 0) {
            const response = await loadCurrencies();
            props.dispatch({
                type: "xCurrencies/get",
                currenciesState: response,
            } as any);
        }

        if ((props.getState() as CustomAppState).xLoadCurrencies.currenciesState) {
            const currencyUSD = (props.getState() as CustomAppState).xLoadCurrencies.currenciesState?.find(
                (currency: CurrencyType) => currency.currencyCode === "USD",
            );
            if (currencyUSD) {
                const cookies = new Cookies(null, { path: '/' });
                cookies.set('CurrentCurrencyId', (currencyUSD as any).id);
            }
        }
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
